import { THEMES_REUSE_ACTION as ACTION_TYPE } from '../types/actionTypes';
const reducer = (state, action) => {
  const {
    type,
    payload
  } = action;
  switch (type) {
    case ACTION_TYPE.SET_SUGGESTED_THEMES:
      {
        if (!('suggestedThemes' in payload && payload.suggestedThemes !== undefined)) {
          break;
        }
        return Object.assign(Object.assign({}, state), {
          suggestedThemes: Object.assign(Object.assign({}, state.suggestedThemes), payload.suggestedThemes)
        });
      }
    case ACTION_TYPE.SET_SUGGESTED_THEMES_FOR_RESPONSE:
      {
        if (!('suggested' in payload && payload.suggested !== undefined) && !('responseTextId' in payload && payload.responseTextId !== undefined)) {
          break;
        }
        // update themes for this response
        const newSuggestedThemes = Object.assign({}, state.suggestedThemes);
        newSuggestedThemes[payload.responseTextId] = payload.suggested;
        return Object.assign(Object.assign({}, state), {
          suggestedThemes: newSuggestedThemes
        });
      }
    case ACTION_TYPE.SET_PREVIOUSLY_USED_THEMES:
      {
        if (!('previouslyUsedThemes' in payload && payload.previouslyUsedThemes !== undefined)) {
          break;
        }
        return Object.assign(Object.assign({}, state), {
          previouslyUsedThemes: payload.previouslyUsedThemes
        });
      }
    case ACTION_TYPE.SET_USE_CASES:
      {
        if (!('useCases' in payload && payload.useCases !== undefined)) {
          break;
        }
        return Object.assign(Object.assign({}, state), {
          useCases: payload.useCases
        });
      }
    case ACTION_TYPE.SET_SELECTED_USE_CASE:
      {
        if (!('selectedUseCase' in payload && payload.selectedUseCase !== undefined)) {
          break;
        }
        return Object.assign(Object.assign({}, state), {
          selectedUseCase: payload.selectedUseCase
        });
      }
    case ACTION_TYPE.SET_SELECTED_REUSED_THEMES:
      {
        if (!('selectedReusedThemes' in payload && payload.selectedReusedThemes !== undefined)) {
          break;
        }
        return Object.assign(Object.assign({}, state), {
          selectedReusedThemes: payload.selectedReusedThemes
        });
      }
    case ACTION_TYPE.ADD_REUSED_THEME:
      {
        if (!('reusedTheme' in payload && payload.reusedTheme !== undefined)) {
          break;
        }
        return Object.assign(Object.assign({}, state), !state.selectedReusedThemes.includes(payload.reusedTheme) && {
          selectedReusedThemes: [...state.selectedReusedThemes, payload.reusedTheme]
        });
      }
    case ACTION_TYPE.REMOVE_REUSED_THEME:
      {
        if (!('reusedTheme' in payload && payload.reusedTheme !== undefined)) {
          break;
        }
        return Object.assign(Object.assign({}, state), {
          selectedReusedThemes: state.selectedReusedThemes.filter(s => s !== payload.reusedTheme)
        });
      }
    case ACTION_TYPE.ADD_PREVIOUSLY_USED_THEME:
      {
        if (!('previouslyUsedTheme' in payload && payload.previouslyUsedTheme !== undefined)) {
          break;
        }
        return Object.assign(Object.assign({}, state), !state.previouslyUsedThemes.includes(payload.previouslyUsedTheme) && {
          previouslyUsedThemes: [payload.previouslyUsedTheme, ...state.previouslyUsedThemes]
        });
      }
    case ACTION_TYPE.REMOVE_PREVIOUSLY_USED_THEME:
      {
        if (!('previouslyUsedTheme' in payload && payload.previouslyUsedTheme !== undefined)) {
          break;
        }
        return Object.assign(Object.assign({}, state), {
          previouslyUsedThemes: state.previouslyUsedThemes.filter(s => s !== payload.previouslyUsedTheme)
        });
      }
    // sometimes we need to update multiple state values at once
    case ACTION_TYPE.SET_MULTIPLE:
      {
        return Object.assign(Object.assign({}, state), payload);
      }
    default:
      {
        break;
      }
  }
  throw new Error(`Unknown action: ${type}`);
};
export default reducer;